package org.hs_soft.runmynesto.domain.model.home.user.add_new_user


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class CashAssist(
    @SerialName("createMutation")
    val createMutation: CreateMutation?
)